module.exports = __webpack_public_path__ + "static/media/stareway-blue.79605863.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/stareway-blue.png
// module id = 408
// module chunks = 0